import { render, staticRenderFns } from "./templateManage.vue?vue&type=template&id=e1897702&scoped=true&"
import script from "./templateManage.vue?vue&type=script&lang=js&"
export * from "./templateManage.vue?vue&type=script&lang=js&"
import style0 from "./templateManage.vue?vue&type=style&index=0&id=e1897702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1897702",
  null
  
)

export default component.exports